import React, { Component } from 'react';
import { connect } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Datatable from '../../../common/datatable';
import { getPipEposDataMissingWeeks, patchResetStrikeCounter } from '../../../../actions/pip-epos-data-missing-weeks';

class PipEposSubmissionsMissingWeeks extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getPipEposDataMissingWeeks());
  }

  render() {
    const { pipEposDataMissingWeeks } = this.props;

    const columns = [
      {
        prop: 'missing-weeks-of-sale',
        title: 'Missing Weeks of Sale',
        format(name) {
          const tooltip = <Tooltip id="tooltip">{name.map((i, index) => <div key={index}>{i}<br /></div>)}</Tooltip>;

          return (
            <OverlayTrigger placement="right" overlay={tooltip}>
              <div>
                {name.slice(0, 3).map((i, index) => <div key={index}>{i}<br /></div>)}
              </div>
            </OverlayTrigger>
          );
        }
      },
      {
        prop: 'name',
        title: 'Outlet Name'
      },
      {
        prop: 'customer-number',
        title: 'Customer Number'
      }
    ];

    const actions = [
      {
        label: 'Reset Strike Counter',
        callback: (row) => {
          const { dispatch } = this.props;

          dispatch(patchResetStrikeCounter(row.attributes['customer-number']));
        }
      }
    ];

    return (
      <div>
        <div className="mg-bottom-30"></div>
        <Datatable
          hideId
          data={pipEposDataMissingWeeks || []}
          columns={columns}
          actions={actions}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  pipEposDataMissingWeeks: state.pipEposDataMissingWeeks.pipEposDataMissingWeeks
});

export default connect(mapStateToProps)(PipEposSubmissionsMissingWeeks);
